import { Fragment, memo } from 'react';

import { Text } from '@Sage/hoi-poi-ui';
import { capitalize } from '@Sage/ssm-utils';

import { InfoRow, InfoRowSection } from 'containers/components/EntityDetailV2';

import SubtitleContent from '../../../shared/SubtitleContent';
import { getCallParticipant, getDurationText } from '../../../../utils/activities';
import ActivityDetailContainer from '../ActivityDetailContainer';

const CallDetail = memo(({ activity, labels, shared }) => {
    const { companyContent, opportunityRow, rightContent, titleRow } = shared;

    let isReceived = false;

    if (activity.IsReceived === '0' || activity.IsReceived === 0) isReceived = true;
    else if (activity.IsReceived === '1' || activity.IsReceived === 1) isReceived = false;

    const labelFromTo = isReceived ? labels.from : labels.to;
    const durationText = getDurationText(activity.Duration);

    const callParticipant = getCallParticipant(activity);
    const phoneContactContent = callParticipant?.entity ? (
        <SubtitleContent
            id={callParticipant.id}
            value={callParticipant.value}
            entity={callParticipant.entity}
        />
    ) : callParticipant?.value ? (
        <Text>{callParticipant.value}</Text>
    ) : null;

    return (
        <ActivityDetailContainer
            activity={activity}
            content={{
                main: (
                    <InfoRowSection>
                        <InfoRow label={labels.duration} value={durationText} />
                    </InfoRowSection>
                ),
                right: (
                    <Fragment>
                        {titleRow}
                        <InfoRowSection>
                            <InfoRow
                                label={capitalize(labelFromTo)}
                                content={phoneContactContent}
                                rightContent={rightContent}
                            />
                            <InfoRow label={labels.account} content={companyContent} />
                            <InfoRow label={labels.role} value={activity.ContactRole} />
                            {opportunityRow}
                        </InfoRowSection>
                    </Fragment>
                ),
            }}
        />
    );
});

CallDetail.displayName = 'CallDetail';

export default CallDetail;
